import useBIMClass from "./useBIMClass";

export default function BIMClass2(props) {
    const { Component, id, ...restProps } = props;

    const bimClassQuery = useBIMClass(id);

    if (!id) return undefined;

    if (bimClassQuery.loading) throw new Promise((resolve) => setTimeout(resolve, 100));
    if (bimClassQuery.error) return undefined;
    if (!bimClassQuery.data?.bimClass) return undefined;

    return (
        <Component
            { ...restProps }
            { ...bimClassQuery.data.bimClass }
        />
    );
}
